/* eslint-disable jsx-a11y/anchor-is-valid */
import { any, string } from "prop-types";
import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";

export function BreadCrumbs({ items }) {
  const history = useHistory()
  if (!items || !items.length) {
    return "";
  }
  let path;
  let text;
  let len = items.length;
  let num;
  if (items.length > 2) {
    num = 2
  } else {
    num = 1
  }
  let title;
  items.forEach((val => {
    if (val?.path?.length > 0) {
      val.path.forEach((item) =>
        title = title ? (title + "." + item) : item)
    }
  }))

  const handlePath = (id) => {
    history.replace({
      pathname: `/products/productCategory1/productCategoryCard/${id}`,
      state: {
        parentCategoryId: id,

      },
    })
  }
  return (
    <ul className="breadcrumb breadcrumb-transparent breadcrumb-dot font-weight-bold p-0 my-2">
      <li className="breadcrumb-item">
        <i className="flaticon2-shelter text-muted icon-1x" />
      </li>
      {items.map((item, index) => (
        text = (index + num) !== len ? item.pathname : (item.pathname.replace(/[0-9]/g, '')),
        path = path ? (path + text) : text,
        <>
          {typeof (item.title) === 'string' ?
            <li key={`bc${index}`} className="breadcrumb-item">
              <Link className="text-muted" to={{ pathname: path }}>
                {item.title}
              </Link>
            </li>
            :
            item?.title?.map((item) =>
              <li key={`bc${index}`} className="breadcrumb-item">
                <Link className="text-muted" onClick={() => { handlePath(item.key) }} >
                  {item.value}
                </Link></li>
            )
          }

        </>

      ))}
    </ul>
  );
}
